export default __webpack_public_path__ + "static/media/img-0456-montenegro-full-face.c77cf8a9.png";